import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AccialCreditNoteAssociationRequest, AccialCreditNoteAssociationResponse } from '../interfaces/accial-credit-note';
import { AccialVoucherSyncResponse } from '../interfaces/accial-voucher-sync';
import { Endpoints } from '../resources/endpoints';

/**
 * Servicios de la integración contable Accial.
 * Las cabeceras (tokenUser, appType, userSession, companyId) las inyecta
 * AppInterceptorService, así que acá sólo va el cuerpo de cada petición.
 */
@Injectable({ providedIn: 'root' })
export class AccialService {

  constructor(
    private http: HttpClient,
    private endpoints: Endpoints
  ) { }

  /** Sube la planilla de recibos de caja para que el backend la sincronice. */
  public syncCashReceiptsXlsx(file: File): Observable<AccialVoucherSyncResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<AccialVoucherSyncResponse>(
      environment.urlServerTeclogi + this.endpoints.accialVouchersSyncXlsx,
      formData
    );
  }

  /** Asocia una lista de notas crédito a sus facturas. */
  public associateCreditNotes(
    associations: AccialCreditNoteAssociationRequest[]
  ): Observable<AccialCreditNoteAssociationResponse> {
    return this.http.post<AccialCreditNoteAssociationResponse>(
      environment.urlServerTeclogi + this.endpoints.accialCreditNotesAssociations,
      associations
    );
  }
}
